import MuiGrid from "@mui/material/Grid";
const Grid = MuiGrid;
export default Grid;
